// Redux Rental Types
export const RENTAL_FETCH_REQUEST = "RENTAL_FETCH_REQUEST";
export const RENTAL_FETCH_SUCCESS = "RENTAL_FETCH_SUCCESS";
export const RENTAL_FETCH_FAILURE = "RENTAL_FETCH_FAILURE";
export const RENTAL_RESET = "RENTAL_RESET";
